import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { API_AUTH_ACTIVATE_FACTOR_URL } from "constants/apiUrls";

import { AuthTransaction } from "../types/authTransaction";
import { OktaError } from "types/oktaError/oktaError";

import useAuthTransactionApiClient from "./useAuthTransactionApiClient";

export type ActivateFactor = {
  stateToken: string;
  passCode: string;
};

function useAuthActivateFactor(): UseMutationResult<
  AuthTransaction,
  OktaError,
  ActivateFactor
> {
  const authTransactionApiClient = useAuthTransactionApiClient();

  return useMutation({
    mutationFn: async (data) => {
      const response = await authTransactionApiClient(
        API_AUTH_ACTIVATE_FACTOR_URL,
        {
          method: "POST",
          body: JSON.stringify(data),
        },
      );

      if (!response.ok) {
        return Promise.reject(await response.json());
      } else {
        return await response.json();
      }
    },
  });
}

export default useAuthActivateFactor;
